import { selectOrNative } from './select-or-native'
import { formId } from './bindForm'

// postInitHook funkce pro letenky
export let letenky = (component, context) => {
  let opts = context.data('opts')

  $('<button class="close-form" type="button"/>').appendTo(formId)
  // globalni funkce postRender, ktera se vola v komponentech airticketForm
  window.airSelectPostRenderFunction = () => {
    selectOrNative(formId)
  }

  let visible = context.find('#visible-part'),
      hidden = context.find('#hidden-part'),

      showMore = `<i class="sa-icon icon-sipka-dolu"></i>${opts.messages.showMore}`,
      showLess = `<i class="sa-icon icon-sipka-dolu up"></i>${opts.messages.showLess}`,

      toggleDiv = $('<div/>', {'class': 'toggle-form'}),
      toggleButton = $(`<a>${showMore}</a>`).appendTo(toggleDiv)

  toggleButton.click(toggleForm)

  toggleDiv.insertBefore(hidden)

  function toggleForm() {
    let hiddenPartIsVisible = hidden.is(':visible'),
        button = context.find('.toggle-form a')

    if (hiddenPartIsVisible) {
      button.html(showMore)
      hidden.hide('fast')
    } else {
      button.html(showLess)
      hidden.show('fast')
    }
  }

  function getIntervalSelect() {
    let instance = null
    $('#form-1').find('select#search_interval').each(function() {
      instance = this.selectInstance
    });
    return instance
  }

  //WEB-3369 defaultné hodnoty intervalu
  window.airticketActivateFormCustom = {
    oneway () {
      let instance = getIntervalSelect()
      if(instance)
        instance.change(String($('#oneway').data('search_interval')))
    },
    round_trip () {
      let instance = getIntervalSelect()
      if(instance)
        instance.change(String($('#round_trip').data('search_interval')))
    },
    open_jaw () {
      let instance = getIntervalSelect()
      if(instance)
        instance.change(String($('#open_jaw').data('search_interval')))
    }
  }
}



// WEBPACK FOOTER //
// ./app/form/postInitHook.js